export default __webpack_public_path__ + "static/media/phpmyadmin-negative.75924037.svg";